import { ManufacturerApi } from './manufacturer-api';
import {
  ManufacturerItem,
  ManufacturerResponse,
  CreateManufacturerRequest,
  UpdateManufacturerRequest,
} from '../types/manufacturer-types';

export class ManufacturerRepository {
  constructor(private readonly api: ManufacturerApi) {}

  async getAll(): Promise<ManufacturerResponse> {
    try {
      return await this.api.getAll();
    } catch (error) {
      console.error('ManufacturerRepository.getAll error:', error);
      throw error;
    }
  }

  async getById(id: number): Promise<ManufacturerItem> {
    try {
      return await this.api.getById(id);
    } catch (error) {
      console.error(`ManufacturerRepository.getById(${id}) error:`, error);
      throw error;
    }
  }

  async create(data: CreateManufacturerRequest): Promise<ManufacturerItem> {
    try {
      return await this.api.create(data);
    } catch (error) {
      console.error('ManufacturerRepository.create error:', error);
      throw error;
    }
  }

  async update(id: number, data: UpdateManufacturerRequest): Promise<ManufacturerItem> {
    try {
      return await this.api.update(id, data);
    } catch (error) {
      console.error(`ManufacturerRepository.update(${id}) error:`, error);
      throw error;
    }
  }

  async delete(id: number): Promise<void> {
    try {
      await this.api.delete(id);
    } catch (error) {
      console.error(`ManufacturerRepository.delete(${id}) error:`, error);
      throw error;
    }
  }
}
